export const initializeExpanders = () => {
	// Find all components with a data-component attribute
	const components = document.querySelectorAll('[data-component]');

	components.forEach((component) => {
		// Find all buttons and contents within the component
		const expanderButtons = component.querySelectorAll('.expander__toggle');
		const expanderContents = component.querySelectorAll('.expander__content');

		// Check if the component has multiple buttons (Recommended Offers) or a single button (Hero Offers)
		const isGrouped = expanderButtons.length > 1;

		expanderButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const isExpanded = button.getAttribute('aria-expanded') === 'true';

				if (isGrouped && window.innerWidth > 980) {
					// For components with multiple buttons (Recommended Offers) on larger screens
					expanderButtons.forEach((btn) => {
						btn.setAttribute('aria-expanded', !isExpanded);
						btn.classList.toggle('o3-button-icon--chevron-down', isExpanded);
						btn.classList.toggle('o3-button-icon--chevron-up', !isExpanded);
					});
					expanderContents.forEach((content) => {
						content.setAttribute('aria-hidden', isExpanded);
					});

					return;
				}

				// For single expanders (Hero Offers) or grouped expanders on smaller screens
				const contentId = button.getAttribute('aria-controls');

				// Using getElementById instead of querySelector because some ids have spaces
				const expanderContent = document.getElementById(contentId);

				if (expanderContent) {
					expanderContent.setAttribute('aria-hidden', isExpanded);
				}
				button.setAttribute('aria-expanded', !isExpanded);
				button.classList.toggle('o3-button-icon--chevron-down', isExpanded);
				button.classList.toggle('o3-button-icon--chevron-up', !isExpanded);
			});
		});
	});
};
